import { atom } from "recoil";

export const withdrawalStatsStore = atom({
	key: "withdrawalStatsStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
